import {Proxy} from "../../../settings";
import {employeeType} from "./getEmployee";
import {basePostRequest} from "../base/basePostRequest";

const postEmployee = async (data: employeeType) =>
  basePostRequest<employeeType>(`${Proxy}/employee/`, data);

export default postEmployee;
